import { ParentRegisterRequest, StudentCreateRequest } from './';

export class ParentRegisterWithStudentsRequestModel {
    ParentRequest: ParentRegisterRequest;
    StudentRequests: StudentCreateRequest[];

    constructor() {
        this.StudentRequests = [];
    }
}